import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FileContentResponse, FileService } from "@core/services/file.service";

export interface FileUploaded {
  controlName: string;
  content: FileContentResponse;
}

@Component({
  selector: "app-upload-file-input",
  templateUrl: "./upload-file-input.component.html",
  styleUrls: ["./upload-file-input.component.scss"],
})
export class UploadFileInputComponent {
  @Input() form!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() tooltipTitle!: string;
  @Input() tooltipText!: string;
  @Input() allowedExtensions: string[] = [];
  @Input() maxSizeMb = 10;

  @Output() fileUploaded = new EventEmitter<FileUploaded>();

  constructor(private _fileService: FileService) { }

  public async onChange(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files) return;

    const fileContent = await this._fileService.getFileContentByInputFile(
      input.files[0],
      this.allowedExtensions,
      this.maxSizeMb
    );

    const data: FileUploaded = {
      controlName: this.controlName,
      content: fileContent,
    };

    this.fileUploaded.emit(data);
  }

  get previewUrl(): string | undefined {
    return this.form?.value?.[this.controlName]?.previewUrl;
  }

  get getFileName(): string {
    return this.form?.value?.[this.controlName]?.fileName || "Selecionar arquivo";
  }

  get acceptTypes(): string {
    return this.allowedExtensions.map((e) => "." + e).join(",");
  }
}
